const INDEX_ITEMS = [
  {
    title: '韩漫人气榜',
    desc: '每周更新，精选韩漫TOP50',
    icon: 'ri-medal-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '日漫经典库',
    desc: '殿堂级日漫作品一网打尽',
    icon: 'ri-book-open-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    title: '国漫新势力',
    desc: '发掘国产漫画新锐作者',
    icon: 'ri-rocket-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    title: '悬疑推理馆',
    desc: '高智商烧脑漫画合集',
    icon: 'ri-search-eye-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '恋爱甜宠屋',
    desc: '糖分超标的恋爱漫画',
    icon: 'ri-heart-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    title: '搞笑日常集',
    desc: '笑到停不下来的爆笑漫画',
    icon: 'ri-emotion-laugh-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    title: '更新日历',
    desc: '追踪每日更新进度不迷路',
    icon: 'ri-calendar-line',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            七大专题入口，快速找到你想看的漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {INDEX_ITEMS.slice(0, 4).map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {INDEX_ITEMS.slice(4).map((item, idx) => (
            <a
              key={idx + 4}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}